import { Module } from "wrapper6";
import Instafeed from "instafeed.js"

export default class InstagramFeed extends Module {
    ready() {
        
        var feed = new Instafeed({
            get: 'user',
            clientId: '6d36c77162a54010879ddc00bb6ba569',
            accessToken: '4715987933.1677ed0.2bed566d30e74ae0939b67276003fd0a',
            userId: '4715987933',
            limit: 8,
            resolution: 'standard_resolution',
            template: '<a class="object-fit" target="_blank" href="{{link}}"><img src="{{image}}" /></a>'
    
        });
        
        if (document.querySelector('#instafeed')) {
            feed.run();
        }
    }
}
